import { DRIVERS_LICENSE_TAG, OTHER_TAG } from '../constants/stipUploadTags';

function isBlank(value) {
  return !(value && String(value).trim());
}

// A Drivers License needs an owner and an expiration date before underwriting
// will accept it. The owner is only the uploader's decision when there is more
// than one on the submission -- a single-owner submission is resolved
// server-side, so we neither ask for nor require it here.
export function ownerRequired(file, ownerCount) {
  return file.tag === DRIVERS_LICENSE_TAG && ownerCount > 1;
}

export function expirationRequired(file) {
  return file.tag === DRIVERS_LICENSE_TAG;
}

export function descriptionRequired(file) {
  return file.tag === OTHER_TAG;
}

// Returns the list of human-readable things still missing for one file, so the
// caller can both disable a button and say why.
export function missingMetadataFor(file, ownerCount) {
  const missing = [];

  if (descriptionRequired(file) && isBlank(file.description)) {
    missing.push('a description');
  }
  if (expirationRequired(file) && isBlank(file.expires_on)) {
    missing.push('an expiration date');
  }
  if (ownerRequired(file, ownerCount) && isBlank(file.owner_uuid)) {
    missing.push('an owner');
  }

  return missing;
}

export function filesMissingMetadata(files, ownerCount) {
  return (files || []).filter(file => missingMetadataFor(file, ownerCount).length > 0);
}
